import request from '@/utils/request'

//获取设备列表
export function getAssetsList (data) {
  return request({
    url: "/api-sp/sp/device/list",
    method: "post",
    data: data,
  })
}

//编辑设备激活
export function updateAutoActivate (data) {
  return request({
    url: "/api-sp/sp/device/updateAutoActivate",
    method: "post",
    data: data,
  })
}

//获取产品线
export function getProductTypeList (data) {
  return request({
    url: "/api-sp/sp/device/getProductTypeList",
    method: "post",
    data: data,
  })
}

//获取设备公告
export function getDeviceNotice () {
  return request({
    url: "/api-sp/sp/device/getDeviceNotice",
    method: "get",
  })
}

//导出设备
export function exprotDeviceApi (data) {
  return request({
    url: "/api-sp/sp/device/export",
    method: "post",
    responseType: 'blob',
    data: data,
  })
}

//获取渠道列表
export function getChannelApi (data) {
  return request({
    url: "/api-sp/sp/device/getChannelList",
    method: "post",
    data: data,
  })
}

//分享设备
export function shareDeviceApi (data) {
  return request({
    url: "/api-sp/sp/device/share",
    method: "post",
    data: data,
  })
}
//取消分享设备
export function unshareDeviceApi (data) {
  return request({
    url: "/api-sp/sp/device/unShare",
    method: "post",
    data: data,
  })
}
//查询添加设备
export function addAssetApi (data) {
  return request({
    url: "/api-sp/sp/device/addAsset",
    method: "post",
    data: data,
  })
}
//添加设备
export function addConfirmApi (data) {
  return request({
    url: "/api-sp/sp/device/addConfirm",
    method: "post",
    data: data,
  })
}

//设备详情
export function deviceDetailApi (data) {
  return request({
    url: "/api-sp/sp/device/detail",
    method: "post",
    data: data,
  })
}

//上传激活文件
export function uploadDeviceApi (data, config) {
  return request({
    url: "/api-sp/sp/device/uploadDeviceInfo",
    method: "post",
    data: data,
    onUploadProgress: config.onUploadProgress
  })
}

//下载授权文件
export function downloadLicenseApi (data) {
  return request({
    url: "/api-sp/sp/device/downloadLicense",
    method: "post",
    data: data,
    responseType: 'blob',
  })
}
//激活设备
export function applyLicenseApi (data) {
  return request({
    url: "/api-sp/sp/device/applyLicense",
    method: "post",
    data: data,
  })
}

//超管解绑设备
export function unbindDeviceApi (id) {
  return request({
    url: `/api-sp/sp/device/unbindAsset/${id}`,
    method: "get",
  })
}